import { z as zod } from 'zod';

type Headers = {
  authorization?: string;
  contentType?: string;
  'X-Request-Id'?: string;
};

type Logger = {
  debug(message: string): void;
  error(message: string): void;
};

export type SnippetsOptions = {
  isSSR?: boolean;
  headers?: Headers;
  logger?: Logger;
};

export const SnippetsResponseSchema = zod.record(
  zod.string(),
  zod.record(zod.string(), zod.string())
);

export const SnippetsParamsSchema = zod.object({
  ids: zod.array(zod.string()),
  lang: zod.string()
});

export type SnippetsParams = zod.infer<typeof SnippetsParamsSchema>;
export type SnippetsResponse = zod.infer<typeof SnippetsResponseSchema>;
